// extracted by mini-css-extract-plugin
export var content = "Accordion-module--content--eb883";
export var core = "Accordion-module--core--e6bb0";
export var heading = "Accordion-module--heading--83752";
export var open = "Accordion-module--open--74a96";